<div fxLayout="column" class="cipo--height--full">
    <div>
        @if (config().searchable) {
            <div fxLayoutAlign="space-between center" class="m-b-md">
                <ng-content></ng-content>
                <span></span>
                <mat-form-field class="cipo-input p-0">
                    <mat-label>{{ "general.search" | translate }}</mat-label>
                    <input matInput [formControl]="searchControl" data-testid="searchable-listbox-search" />
                    @if (searchControl.value) {
                        <button
                            matSuffix
                            [title]="'general.clear' | translate"
                            [attr.aria-label]="'general.clear' | translate"
                            mat-icon-button
                            (click)="clearInput()">
                            <mat-icon aria-hidden="true">close</mat-icon>
                        </button>
                    } @else {
                        <mat-icon matSuffix>search</mat-icon>
                    }
                </mat-form-field>
            </div>
        }
        @if (config().noFoundMessage && filteredOptions() && !filteredOptions().length) {
            <span fxLayoutAlign="center start" class="m-t-lg">{{ config().noFoundMessage | translate }}</span>
        }
    </div>
    <div fxFlex class="list-content" tabindex="0">
        @if (loading()) {
            @for (item of skeleton(); track $index) {
                <div>
                    @for (column of skeletonColumns(); track $index) {
                        <ngx-skeleton-loader
                            [theme]="{
                                width: 100 / config().columns - 5 + '%',
                                height: '40px',
                                'border-radius': '15px',
                                marginRight: '10px',
                                marginBottom: '10px',
                            }" />
                    }
                </div>
            }
        } @else {
            <cipo-selectable-listbox
                class="cipo--height--full"
                [ariaLabel]="config().ariaLabel"
                [columns]="config().columns"
                [multiple]="config().multiple"
                [options]="filteredOptions() || []"
                [values]="values() || []"
                (valuesChange)="values.set($event)" />
        }
    </div>
</div>
